import { getCustomerTeam, getCustomer } from "../graphql/queries";

import gql from "graphql-tag";
import { myGetCustomer, myGetCustomerExtended } from "../data/customQueries";
import moment from "moment";
let tractor = require("../assets/img/tractor-128.png");
let van = require("../assets/img/van.png");
let bus = require("../assets/img/bus.png");
let truck = require("../assets/img/truck.png");
let trailer = require("../assets/img/trailer.png");
let pickup = require("../assets/img/pickup.png");
export const utilGetVehicleImage = vehCategory => {
  let src = "";
  switch (vehCategory) {
    case "TRACTOR":
      src = tractor;
      break;
    case "TRUCK":
      src = truck;
      break;
    case "TRAILER":
      src = trailer;
      break;
    case "VAN":
      src = van;
      break;
    case "BUS":
      src = bus;
      break;
    case "PICKUPTRUCK":
      src = pickup;
      break;
  }
  return src;
};
export const getUserType = user => {
  let userType = null;
  if (
    user !== null &&
    user !== "notFound" &&
    user.signInUserSession.idToken.payload["cognito:groups"] !== undefined
  ) {
    userType = user.signInUserSession.idToken.payload["cognito:groups"][0];
  }
  return userType;
};
export const utilGetCustomer = async (user, client) => {
  let custId = user.id;
  let userType = getUserType(user);
  if ((userType === "Dispatchers") | (userType === "Technicians")) {
    let custTeam = (await client.query({
      query: gql(getCustomerTeam),
      fetchPolicy: `network-only`,
      variables: { id: user.username }
    })).data.getCustomerTeam;
    custId = custTeam.customer.id;
  }
  return (await client.query({
    query: gql(myGetCustomer),
    fetchPolicy: `network-only`,
    variables: { id: custId, limit: 1000 }
  })).data.getCustomer;
  //return cust;
};

export const utilGetCustomerExtended = async (user, client) => {
  let custId = user.id;
  let userType = getUserType(user);
  if ((userType === "Dispatchers") | (userType === "Technicians")) {
    let custTeam = (await client.query({
      query: gql(getCustomerTeam),
      fetchPolicy: `network-only`,
      variables: { id: user.username }
    })).data.getCustomerTeam;
    custId = custTeam.customer.id;
  }
  return (await client.query({
    query: gql(myGetCustomerExtended),
    fetchPolicy: `network-only`,
    variables: { id: custId, limit: 1000 }
  })).data.getCustomer;
  //return cust;
};

export const utilGetInspectionType = customerRegType => {
  if (customerRegType === "FEDERAL") return "DOT_ANNUAL_INSPECTION";
  else if (customerRegType === "BIT") return "BIT_90DAY_INSPECTION";
  else if (customerRegType === "BUS_LIMOS") return "BIT_45DAY_INSPECTION";
  else if (customerRegType === "FEDERAL_BIT")
    return "DOTANDBIT";
};

export const utilSkipLeapYear = (inspectionType, inspDate) => {
  if (inspectionType === "DOT_ANNUAL_INSPECTION") {
    // _nextInspectionDue_ = moment(inspDate).add(1, "year");
    return moment(inspDate)
      .add(1, "year")
      .toISOString()
      .split("T")[0];
  } else if (inspectionType === "BIT_90DAY_INSPECTION") {
    const startDate = moment(inspDate);
    const endDate = moment(inspDate).add(90, "days");
    const y1 = startDate.year();
    const y2 = endDate.year();
    const compareDate1 = moment(`29/02/${y1}`, "DD/MM/YYYY");
    const compareDate2 = moment(`29/02/${y2}`, "DD/MM/YYYY");
    const inRange1 = compareDate1.isBetween(startDate, endDate, "days", "[]");
    const inRange2 = compareDate2.isBetween(startDate, endDate, "days", "[]");
    if (inRange1 || inRange2) {
      // _nextInspectionDue_ = moment(inspDate).add(91, "days");
      return moment(inspDate)
        .add(91, "days")
        .toISOString()
        .split("T")[0];
    } else {
      // _nextInspectionDue_ = moment(inspDate).add(90, "days");
      return moment(inspDate)
        .add(90, "days")
        .toISOString()
        .split("T")[0];
    }
  } else if (inspectionType === "BIT_45DAY_INSPECTION") {
    const startDate = moment(inspDate);
    const endDate = moment(inspDate).add(45, "days");
    const y1 = startDate.year();
    const y2 = endDate.year();
    const compareDate1 = moment(`29/02/${y1}`, "DD/MM/YYYY");
    const compareDate2 = moment(`29/02/${y2}`, "DD/MM/YYYY");
    const inRange1 = compareDate1.isBetween(startDate, endDate, "days", "[]");
    const inRange2 = compareDate2.isBetween(startDate, endDate, "days", "[]");
    if (inRange1 || inRange2) {
      // _nextInspectionDue_ = moment(inspDate).add(46, "days");
      return moment(inspDate)
        .add(46, "days")
        .toISOString()
        .split("T")[0];
    } else {
      // _nextInspectionDue_ = moment(inspDate).add(45, "days");
      return moment(inspDate)
        .add(45, "days")
        .toISOString()
        .split("T")[0];
    }
  } else if (inspectionType === "DOTANDBIT") {
    const startDate = moment(inspDate);
    const endDate = moment(inspDate).add(90, "days");
    const y1 = startDate.year();
    const y2 = endDate.year();
    const compareDate1 = moment(`29/02/${y1}`, "DD/MM/YYYY");
    const compareDate2 = moment(`29/02/${y2}`, "DD/MM/YYYY");
    const inRange1 = compareDate1.isBetween(startDate, endDate, "days", "[]");
    const inRange2 = compareDate2.isBetween(startDate, endDate, "days", "[]");
    if (inRange1 || inRange2) {
      // _nextInspectionDue_ = moment(inspDate).add(91, "days");
      return [
        moment(inspDate)
          .add(1, "year")
          .toISOString()
          .split("T")[0],
        moment(inspDate)
          .add(91, "days")
          .toISOString()
          .split("T")[0]
      ];
    } else {
      // _nextInspectionDue_ = moment(inspDate).add(90, "days");
      return [
        moment(inspDate)
          .add(1, "year")
          .toISOString()
          .split("T")[0],
        moment(inspDate)
          .add(90, "days")
          .toISOString()
          .split("T")[0]
      ];
    }
  }
};



// WEBPACK FOOTER //
// ./src/common/util.js